import styled from 'styled-components';

export const OwnerFormContainer = styled.div`
  min-width: 825px;
  max-width: 1024px;
`;
